import { useState } from 'react';

import { mockData } from './mockData';

const useData = () => {
    const [data] = useState(mockData);

    const fetch = () => {};

    return {
        data,
        fetch
    };
};

export default useData;
